import { render } from "./NewInvoiceInventoryDetail.vue?vue&type=template&id=35f21328"
import script from "./NewInvoiceInventoryDetail.vue?vue&type=script&lang=js"
export * from "./NewInvoiceInventoryDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__